import {css} from 'styled-components';
import logoAzn from '../icons/azn/logo-alzheimer.png';
import progress1 from '../icons/azn/new-step-indicator-1.svg';
import progress2 from '../icons/azn/new-step-indicator-2.svg';
import progress3 from '../icons/azn/new-step-indicator-3.svg';
import progress1of2 from '../icons/azn/new-step-indicator-1of2.svg';
import progress2of2 from '../icons/azn/new-step-indicator-2of2.svg';
import whatsapp from '../icons/sho/whatsapp.png';
import facebook from '../icons/sho/facebook.svg';
import linkedin from '../icons/sho/linkedin.svg';
import instagram from '../icons/sho/instagram.svg';
import twitter from '../icons/sho/x.svg';

const palette = {
  black: '#000000',
  grey600: '#736D64',
  grey400: '#EDE7E1',
  grey200: '#F8F2EC',
  white: '#FFFFFF',
  yellow200: '#FBD242',
  yellow400: '#E4BB2B',
  magenta200: '#DE2C68',

  selected: '#559760',
  selectedSoft: '#F3FAF6',
  error: '#EC407A',
  errorHard: '#E8141E',
  errorSoft: '#FFE5E6'
};

const primaryColor = palette.yellow200;
const hoveredColor = palette.yellow400;

const mainFont = '"Raisonne AN DemiBold", "Open Sans", sans-serif';
const smallFont = '"Open Sans", sans-serif';
const smallFontBold = '"Open Sans SemiBold", sans-serif';

const defaultBorder = `1px solid ${palette.grey600}`;
const inputBorderStyle = {
  border: defaultBorder,
  borderHover: `2px solid ${palette.grey600}`,
  borderValid: `2px solid ${palette.selected}`,
  borderFocus: `thick double ${palette.black}`,
  borderDisabled: `1px solid ${palette.grey400}`,
  borderError: `1px solid ${palette.grey600}`
};

export default {
  // Global Style:
  primaryColor,
  bodyFontFamily: smallFont,
  bodyFontSize: '15px',
  h1FontFamily: mainFont,
  h1FontSize: '22px',
  h3FontFamily: mainFont,
  step2WidgetHeaderText: 'Stap 2: Mijn gegevens',
  step3WidgetHeaderText: 'Stap 3: Betaling',
  step3WidgetHeaderTextNoNaw: 'Stap 2: Betaling',

  smallHeader: true,
  allowNewsletterDefault: true,
  hideProgressBarLead: true,

  /// Components:
  linkHoverColor: palette.magenta200,
  backButton: {
    fontSize: '15px',
    color: palette.black
  },
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: cover;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      width: 100%;
      height: 100%;
      background-color: white;
      background-size: contain;
      background-position-y: top;
      background-position-x: left;
      background-repeat: no-repeat;
      inset: initial;
      z-index: -1;
      background-attachment: local;
    }
  `,
  boxComponent: {
    borderRadius: '12px'
  },
  iban: {
    fontFamily: mainFont,
    color: palette.white
  },
  ibanContainer: {
    display: 'none'
  },
  // todo bold and nudge into border of label
  label: {
    fontSize: '15px',
    color: palette.black,
    colorError: palette.error
  },
  logo: {
    width: '210px',
    height: '180px',
    backgroundImage: logoAzn,
    widthMobile: '120px',
    heightMobile: '103px',
    margin: '0',
    marginMobile: '0'
  },
  optionalLabel: {
    color: palette.grey600,
    display: 'none'
  },
  orderSummary: {
    labelFontSize: '15px',
    labelFontWeight: 'bold',
    fontSize: '15px',
    subText: css`
      content: 'Verzending gratis';
      color: ${palette.selected};
    `
  },
  privacyLabel: {
    standard: {
      lineHeight: '1.4em'
    },
    lead: {
      color: palette.grey600,
      fontSize: '14px'
    },
    petition: {
      color: palette.grey600,
      fontSize: '14px'
    }
  },
  productPage: {
    amountPadding: '0 10px 0 16px',
    amountColor: palette.black,
    extraAmountWidth: '100px',
    deliveryTextColor: palette.selected
  },
  progressBar: {
    height: '32px',
    step1: css`
      width: 96px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 96px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 96px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 64px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 64px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  requiredLabel: {
    color: palette.black,
    display: 'inline'
  },
  socialShareButton: {
    backgroundSize: '50px',
    color: palette.black,
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  subtleText: {
    color: palette.grey600,
    fontStyle: 'normal'
  },
  teaser: {
    display: 'block',
    fontFamily: mainFont,
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '32px',
    fontSizeTablet: '18px',
    lineHeightTablet: '32px',
    fontSizeWide: '20px',
    lineHeightWide: '32px',
    subtitleFontFamily: smallFont,
    subtitleFontSize: '15px',
    subtitleLineHeight: '25px',
    subtitleFontSizeWide: '15px',
    subtitleLineHeightWide: '25px',
    subtitleFontSizeTablet: '15px',
    subtitleLineHeightTablet: '25px',
    backgroundColor: palette.grey200,
    backgroundColorSubtitle: palette.white,
    color: palette.black,
    colorSubtitle: palette.black,
    padding: '3px 20px',
    // paddingTopSubtitle: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'left',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'left'
  },
  teaserContainer: {
    margin: '0'
  },
  telemarketingText: {
    color: palette.grey600,
    lineHeight: '1.4em'
  },
  title: {
    color: palette.black,
    fontFamily: mainFont,
    fontSize: '18px',
    height: '60px',
    fontWeight: 'normal',
    borderRadius: '12px',
    backgroundColor: palette.grey200
  },
  validation: {
    color: palette.errorHard,
    fontSize: '15px'
  },
  /// Components - Input
  amountButton: {
    color: palette.black,
    fontFamily: smallFontBold,
    fontWeightActive: 'bold',
    fontSize: '16px',
    height: '52px',
    width: 'calc(50% - 7px)',
    ribbonHeight: '28%',
    ribbonTop: '74%',
    ribbonFont: smallFontBold,
    ribbonFontWeight: 'bold',
    border: defaultBorder,
    ribbonColor: palette.selected,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.selectedSoft,
    borderHover: `2px solid ${palette.selected}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.selected}`,
    padding: '1px 0',
    paddingHover: '0',
    ribbonPaddingBottom: '2px'
  },
  frequencyButton: {
    color: palette.black,
    fontFamily: smallFontBold,
    fontWeightActive: 'bold',
    fontSize: '16px',
    height: '52px',
    width: 'calc(50% - 7px)',
    ribbonHeight: '28%',
    ribbonTop: '74%',
    ribbonFont: smallFontBold,
    ribbonFontWeight: 'bold',
    border: defaultBorder,
    ribbonColor: palette.selected,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.selectedSoft,
    borderHover: `2px solid ${palette.selected}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.selected}`,
    padding: '1px 0',
    paddingHover: '0',
    ribbonPaddingBottom: '2px'
  },
  buttonContainerSpaceBetween: {
    width: '110px',
    rowGap: '14px',
    justifyContent: 'space-between'
  },
  frequencyButtonContainer: {
    width: '110px',
    rowGap: '14px',
    justifyContent: 'space-between'
  },
  // Checkbox
  inputCheckbox: {
    label: {
      color: palette.grey600,
      fontSize: '14px',
      display: 'block',
      lineHeight: '1.4em'
    },
    borderRadius: '4px',
    ...inputBorderStyle
  },
  box: {
    fontSize: '15px',
    colorHasError: palette.error,
    backgroundColorChecked: palette.white,
    backgroundBorderChecked: `1px solid ${palette.black}`,
    fillColorChecked: palette.black,
    borderHasError: `1px solid ${palette.error}`,
    ...inputBorderStyle
  },
  inputComponent: {
    fontSize: '15px',
    borderRadius: '8px',
    colorPlaceholder: palette.grey600,
    colorError: palette.error,
    backgroundColorValid: palette.white,
    backgroundColor: palette.white,
    ...inputBorderStyle
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    fontFamily: smallFontBold,
    fontSize: '18px',
    height: '52px',
    backgroundColor: primaryColor,
    color: palette.black,
    boxShadow: 'none',
    active: css`
      background-color: ${hoveredColor};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${hoveredColor};
    `,
    focus: css`
      box-shadow: none;
    `
  },
  error: {
    backgroundColor: palette.errorSoft,
    color: palette.error,
    height: '49px'
  },
  // RadioButton
  radio: {
    colorHasError: palette.error,
    padding: '0 10px 0 28px',
    gap: '0.5rem',
    borderHasError: `1px solid ${palette.error}`,
    ...inputBorderStyle
  },
  inputRadioButton: {
    backgroundColor: palette.white,
    backgroundColorActive: palette.white,
    borderActive: `6px solid ${palette.selected}`,
    fontWeightActive: 'bold',
    fillColor: 'transparent',
    fillTop: '3px',
    fillLeft: '3px',
    fillWidth: '14px',
    fillHeight: '14px',
    fontSize: '15px',
    ...inputBorderStyle
  },
  textAreaComponent: {
    fontSize: '15px',
    borderRadius: '8px',
    colorPlaceholder: palette.grey600,
    colorError: palette.error,
    ...inputBorderStyle,
    rows: 1,
    marginBottom: '8px',
    marginBottomHover: '6px',
    marginBottomFocus: '0px'
  },
  // PaymentButton
  paymentButton: {
    color: palette.black,
    fontFamily: smallFont,
    fontSize: '12px',
    width: 'calc(50% - 7px);',
    height: '78px',
    lineHeight: '78px',
    border: defaultBorder,
    borderRadius: '8px',
    backgroundColor: palette.white,
    backgroundColorActive: palette.selectedSoft,
    borderHover: `2px solid ${palette.selected}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${palette.selected}`,
    padding: '22px 0 2px 0',
    paddingHover: '21px 0 0 0'
  },
  paymentMethodsContainer: {
    width: '110px',
    rowGap: '14px',
    justifyContent: 'space-between',
    labelText: 'Kies betaalmethode',
    labelStyle: {
      color: palette.black,
      fontWeight: 'bold',
      lineHeight: '0'
    }
  },

  // GlobalStyles
  dateDropdown: {
    fontSize: '15px',
    chevronSize: '20px',
    borderRadius: '8px',
    padding: '0px 10px',
    boxShadowError: `0 0 0 1px ${palette.error}`,
    boxShadowValid: `0 0 0 1px ${palette.selected}`,
    ...inputBorderStyle
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '8px',
    backgroundColor: palette.white,
    fontSize: '16px',
    chevronSize: '20px',
    paddingLeft: '13px',
    ...inputBorderStyle
  },
  // OptIn
  optInButton: {
    fontFamily: mainFont,
    fontSize: '20px',
    backgroundColor: palette.grey200,
    color: palette.black,
    boxShadow: 'none',
    borderRadius: '8px',
    active: css`
      background-color: ${palette.yellow400};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${palette.yellow400};
    `,
    focus: css`
      box-shadow: none;
    `
  },
  personalMessage: {
    buttonFontSize: '15px',
    marginBottom: '8px',
    fontFamily: mainFont,
    fontSize: '15px',
    backgroundColor: palette.grey200,
    color: palette.black,
    boxShadow: 'none',
    borderRadius: '8px',
    active: css`
      background-color: ${palette.yellow400};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${palette.yellow400};
    `,
    focus: css`
      box-shadow: none;
    `
  }
};
